const selectors = {
  circleText: '[data-circle-text]',
};

const classes = {
  isDisabled: 'is-disabled',
}

const attributes = {
  circleTextParallax: 'data-circle-text-parallax',
};

const sections = {};

class CircleText {
  constructor(el) {
    this.circleText = el;
    this.rotateDegree = 70;
    this.adjustRotateDegree = this.rotateDegree / 2; // We use this to keep the image upright when scrolling and it gets to the middle of the page

    this.scrollEvent = () => this.updateParallax();
    this.init();
  }

  init() {
    if (this.circleText.hasAttribute(attributes.circleTextParallax)) {
      document.addEventListener('theme:scroll', this.scrollEvent);
    }
  }

  updateParallax() {
    if (this.circleText.classList.contains(classes.isDisabled)) return;

    const windowHeight = Math.round(window.innerHeight);
    const scrollTop = Math.round(window.scrollY);
    const scrollBottom = scrollTop + windowHeight;
    const elementOffsetTopPoint = Math.round(this.circleText.getBoundingClientRect().top + scrollTop);
    const elementHeight = this.circleText.offsetHeight;
    const elementOffsetBottomPoint = elementOffsetTopPoint + elementHeight;
    const isBottomOfElementPassed = elementOffsetBottomPoint < scrollTop;
    const isTopOfElementReached = elementOffsetTopPoint < scrollBottom;
    const isInView = isTopOfElementReached && !isBottomOfElementPassed;

    if (isInView) {
      const scrollProgress = scrollBottom - elementOffsetTopPoint - elementHeight/2;
      const percentage = scrollProgress * 100 / windowHeight;
      let angle = this.rotateDegree * percentage / 100 * -1; // The -1 negates the value to have it rotate counterclockwise

      if (percentage > 0) {
        this.circleText.style.transform = `rotate(${this.adjustRotateDegree + angle}deg)`;
      }
    }
  }

  unload() {
    document.removeEventListener('theme:scroll', this.scrollEvent);
  }
}

const circleText = {
  onLoad() {
    sections[this.id] = [];
    const elements = this.container.querySelectorAll(selectors.circleText);
    elements.forEach((circleText) => {
      sections[this.id].push(new CircleText(circleText));
    });
  },
  onUnload() {
    sections[this.id].forEach((circleText) => {
      if (typeof circleText.unload === 'function') {
        circleText.unload();
      }
    });
  },
};

export {circleText, CircleText};
